import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAccessToken } from "@/lib/api/client";

export const Route = createFileRoute("/")({
  // No `head:` here on purpose. `beforeLoad` below always throws a redirect, so this
  // route never renders and any head metadata it declared would be dead code — the
  // router resolves `head` only after `beforeLoad` resolves without redirecting.
  // That also means "/" cannot host the site's Organization/WebSite JSON-LD; it needs
  // a route that actually returns HTML.
  beforeLoad: () => {
    // The auth token lives in localStorage and is unreadable during SSR, so the server
    // sends every visitor (including crawlers) to /login and the client corrects for
    // authenticated users on hydration.
    if (typeof window === "undefined") {
      throw redirect({ to: "/login" });
    }

    throw redirect({ to: getAccessToken() ? "/home" : "/login" });
  },
});
